module.exports = __webpack_public_path__ + "img/38.4c6bb6b1.jpg";